import React from 'react'

export default function Move() {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.6994 8.69936V8.65672C18.678 8.65672 18.678 8.65672 18.6567 8.65672L16.0768 6.07676V8.69936C14.7548 8.72068 12.6226 8.69936 11.3006 8.69936V3.92324H13.8806L10 0L6.03411 3.92324H8.742V8.69936C7.42004 8.69936 5.2452 8.67804 3.92324 8.65672V6.07676L0 10L3.92324 13.9232V11.258C5.2452 11.258 7.42004 11.258 8.742 11.258V13.8806V16.0768H6.03411L10 20L13.8806 16.0768H11.3006V13.8806V11.258C12.6013 11.258 14.7761 11.258 16.0768 11.258V13.9232L18.6994 11.258L20 10L18.6994 8.69936Z" fill="#BBBBBB" fillOpacity="0.7"/>
  </svg>
}
